import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";

import SettingsOptionButton from "./settings-option-button";
import SettingsOptionSwitch from "./settings-option-switch";
import SettingsOptionChangeAvatar from "./settings-option-change-avatar";
import SettingsOptionLink from "./settings-option-link";

const styles = theme => ({

});

function SettingsOption(props) {
	const { type } = props;

	if (type === "button") {
		return (
			<SettingsOptionButton
				{...props}
			/>
		);
	} else if (type === "switch") {
		return (
			<SettingsOptionSwitch
				{...props}
			/>
		);
	} else if (type === "change-avatar"){
		return (
			<SettingsOptionChangeAvatar
				{...props}
			/>
		)
	} else if(type === "link"){
		return (
			<SettingsOptionLink
				{...props}
			/>
		)
	}
}

SettingsOption.propTypes = {
	name: PropTypes.string.isRequired,
	img: PropTypes.string.isRequired,
	placeholder: PropTypes.string,
	type: PropTypes.string.isRequired,
	isLast: PropTypes.bool,

	classes: PropTypes.shape({
	}).isRequired,

	onClick: PropTypes.func
};

export default withStyles(styles)(SettingsOption);
